import { render } from "./StatsHeading.vue?vue&type=template&id=24f959a8"
import script from "./StatsHeading.vue?vue&type=script&lang=js"
export * from "./StatsHeading.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__